import { jsx as _jsx } from "react/jsx-runtime";
import { createBrowserRouter, Navigate } from 'react-router-dom';
import { lazy, Suspense } from 'react';
import { LoadingScreen } from '../components/ui/LoadingScreen';
import { AppLayout } from '../components/layout/AppLayout';
import { AuthLayout } from '../components/layout/AuthLayout';
import { ProtectedRoute } from '../components/auth/ProtectedRoute';
// Auth pages
const LoginPage = lazy(() => import('../features/auth/pages/LoginPage').then((m) => ({ default: m.LoginPage })));
// Dashboard
const DashboardPage = lazy(() => import('../features/dashboard/pages/DashboardPage').then((m) => ({ default: m.DashboardPage })));
// Customers
const CustomersPage = lazy(() => import('../features/customers/pages/CustomersPage').then((m) => ({ default: m.CustomersPage })));
// Suppliers
const SuppliersPage = lazy(() => import('../features/suppliers/pages/SuppliersPage').then((m) => ({ default: m.SuppliersPage })));
// Products
const ProductsPage = lazy(() => import('../features/products/pages/ProductsPage').then((m) => ({ default: m.ProductsPage })));
// Inventory
const InventoryPage = lazy(() => import('../features/inventory/pages/InventoryPage').then((m) => ({ default: m.InventoryPage })));
// Sales
const SalesPage = lazy(() => import('../features/sales/pages/SalesPage').then((m) => ({ default: m.SalesPage })));
// Purchases
const PurchasesPage = lazy(() => import('../features/purchases/pages/PurchasesPage').then((m) => ({ default: m.PurchasesPage })));
// Treasury
const TreasuryPage = lazy(() => import('../features/treasury/pages/TreasuryPage').then((m) => ({ default: m.TreasuryPage })));
// Accounting
const AccountingPage = lazy(() => import('../features/accounting/pages/AccountingPage').then((m) => ({ default: m.AccountingPage })));
// Reports
const ReportsPage = lazy(() => import('../features/reports/pages/ReportsPage').then((m) => ({ default: m.ReportsPage })));
// Notifications
const NotificationsPage = lazy(() => import('../features/notifications/pages/NotificationsPage').then((m) => ({ default: m.NotificationsPage })));
// Settings
const SettingsPage = lazy(() => import('../features/settings/pages/SettingsPage').then((m) => ({ default: m.SettingsPage })));
// Point of Sale (POS)
const PosPage = lazy(() => import('../features/pos/pages/PosPage').then((m) => ({ default: m.PosPage })));
// Audit Log
const AuditLogPage = lazy(() => import('../features/audit/pages/AuditLogPage').then((m) => ({ default: m.AuditLogPage })));
const withSuspense = (Component) => (_jsx(Suspense, { fallback: _jsx(LoadingScreen, {}), children: _jsx(Component, {}) }));
export const router = createBrowserRouter([
    {
        path: '/auth',
        element: _jsx(AuthLayout, {}),
        children: [
            {
                path: 'login',
                element: withSuspense(LoginPage),
            },
            {
                index: true,
                element: _jsx(Navigate, { to: "login", replace: true }),
            },
        ],
    },
    {
        path: '/',
        element: (_jsx(ProtectedRoute, { children: _jsx(AppLayout, {}) })),
        children: [
            {
                index: true,
                element: _jsx(Navigate, { to: "/dashboard", replace: true }),
            },
            {
                path: 'dashboard',
                element: withSuspense(DashboardPage),
            },
            {
                path: 'pos',
                element: withSuspense(PosPage),
            },
            {
                path: 'customers',
                element: withSuspense(CustomersPage),
            },
            {
                path: 'suppliers',
                element: withSuspense(SuppliersPage),
            },
            {
                path: 'products',
                element: withSuspense(ProductsPage),
            },
            {
                path: 'inventory',
                element: withSuspense(InventoryPage),
            },
            {
                path: 'sales',
                element: withSuspense(SalesPage),
            },
            {
                path: 'purchases',
                element: withSuspense(PurchasesPage),
            },
            {
                path: 'treasury',
                element: withSuspense(TreasuryPage),
            },
            {
                path: 'accounting',
                element: withSuspense(AccountingPage),
            },
            {
                path: 'reports',
                element: withSuspense(ReportsPage),
            },
            {
                path: 'notifications',
                element: withSuspense(NotificationsPage),
            },
            {
                path: 'audit',
                element: withSuspense(AuditLogPage),
            },
            {
                path: 'settings',
                element: withSuspense(SettingsPage),
            },
        ],
    },
    {
        path: '*',
        element: _jsx(Navigate, { to: "/", replace: true }),
    },
]);
//# sourceMappingURL=router.js.map